module.exports = __webpack_public_path__ + "img/logo-product-edi.7435c74a.svg";